import React, { useState, useMemo } from 'react'
import { formatDistanceToNow, compareDesc } from 'date-fns'
import { es } from 'date-fns/locale'
// import Inputmask from 'inputmask';
import VocationStartLogo from '../img/vocation_start_logo.png'
import VocationJuniorLogo from '../img/vocation_junior_logo.png'
import VocationOneLogo from '../img/vocation_one_logo.png'

import {
  Form,
  FormInput,
  SchoolInfoWrapper,
  Row,
  Col,
  Footer,
  ErrorMessage
} from './styles'
import { useDataContext } from '../../../../Context/campaign-context'
import theme from '../../../../theme'

const getQuery = param => {
  if (!param) {
    return null
  }
  const query = new URLSearchParams(window.location.search)
  const result = query.get(param)
  return result
}

const PrevResponses = props => {
  const { SKU } = props
  const [error, setError] = useState('')
  const [rut, setRut] = useState('')
  const {
    campaign,
    userData,
    setUserData,
    loadingUser,
    prevResponses,
    setPrevResponses,
    logInUser
  } = useDataContext()

  // console.log({ prevResponses })
  // const inputEl = useRef(null);

  // // De forma similar a componentDidMount y componentDidUpdate
  // useEffect(() => {
  //   // Actualiza el título del documento usando la API del navegador
  //   if (inputEl.current) {
  //     Inputmask({
  //       mask: '99.999.999-9',
  //       numericInput: true,
  //       jitMasking: true
  //     }).mask(inputEl);
  //   }
  // }, []);

  const onSubmit = async e => {
    e.preventDefault()
    // console.log('submitting', rut);
    const lowerRut = rut.toLowerCase().trim() // lower case rut
    const cleanRut = lowerRut.replace(/_/g, '') // clean "_" chars from rut.
    // console.log({ rut, cleanRut });
    // LOGIN LOGIC!!!
    // console.log('now login on campaign with this rut');
    let currentUser = {}
    let prevResponses = []
    // console.log({ campaign });
    const isClosed = campaign.type === 'closed'
    const isOpened = campaign.type === 'opened'
    const isMixed = campaign.type === 'mixed'

    // check if closed and no participant to return early
    if (isClosed) {
      // console.log('is closed, has to logIn');
      const { participant, responses } = await logInUser({
        field: 'rut',
        value: cleanRut
      })
      // console.log({ participant })
      // console.log({ responses })
      if (!participant) {
        // return early
        return setError(
          `No se encontró participante con Código Acceso: ${cleanRut}`
        )
      }
      currentUser = { ...participant, rut: cleanRut } // login logic has user object with responseID ??
      if (responses) {
        prevResponses = responses
      }
    }

    if (isOpened) {
      // set local user only with rut and continue
      currentUser = { rut: cleanRut } // login logic has user object with responseID ??
    }

    if (isMixed) {
      // console.log('is mixed, has to logIn and continue regardless');
      const { participant, responses } = await logInUser({
        field: 'rut',
        value: cleanRut
      })
      if (!participant) {
        currentUser = { rut: cleanRut }
      }
      if (participant) {
        currentUser = { ...participant, rut: cleanRut } // login logic has user object with responseID ??
      }
      if (responses) {
        prevResponses = responses
      }
    }

    const CURRENT_CODE = `currentCode_${campaign.id}`
    const LOCAL_RESPONSES = `localUserResponses_${campaign.id}`
    const localList = localStorage.getItem(LOCAL_RESPONSES)
    // if responses list, check if current rut has local responseID to continue
    if (localList) {
      const campaignResponseLists = JSON.parse(localList)
      const currUserResponse = campaignResponseLists[cleanRut]
      if (currUserResponse) {
        currentUser = { ...currentUser, responseID: currUserResponse }
      }
    }
    // set responseID from url to continue prev incomplete data
    const urlResponseID = getQuery('rid')
    if (urlResponseID) {
      currentUser = { ...currentUser, responseID: urlResponseID }
    }
    // console.log({ currentUser });
    localStorage.setItem(CURRENT_CODE, cleanRut)
    localStorage.setItem(
      `localUserData_${campaign.id}`,
      JSON.stringify(currentUser)
    )

    await setUserData(currentUser)
    await setPrevResponses(prevResponses)
  }

  // console.log({ campaign });

  const timeDistanceString = useMemo(() => {
    if (campaign.openedAt) {
      return formatDistanceToNow(new Date(campaign.openedAt), {
        addSuffix: true,
        locale: es
      })
    }
  }, [campaign])

  const isOpenedDate = useMemo(() => {
    if (campaign.openedAt) {
      // console.log({ openedAt: new Date(campaign.openedAt) });
      // console.log({ now: new Date() });
      const result = compareDesc(new Date(campaign.openedAt), new Date())
      // console.log({ result });
      return result !== -1 // if not -1, is opened
    }
    // defaults to true if no openedAt value
    return true
  }, [campaign])

  // console.log({ isOpenedDate, timeDistanceString });

  const handleNewResponse = () => {
    const cleanRut = userData.rut // clean "_" chars from rut.
    // console.log({ userData })
    // clean local user data
    const LOCAL_USER_DATA = `localUserData_${campaign.id}`
    if (userData) {
      let currentUser = { ...userData }
      delete currentUser.responseID // remove response reference to local user data
      localStorage.setItem(LOCAL_USER_DATA, JSON.stringify(currentUser))
    }
    // remove local user data to start new clean response
    const LOCAL_FEEDBACK_FORM = `feedbackForm-${campaign.id}-${cleanRut}`
    const LOCAL_GENERAteD_USERID = `userId-${cleanRut}-${campaign.id}`
    const LOCAL_STUDY_PATTERN = `studyItemsPattern-${cleanRut}-${campaign.id}`
    const LOCAL_CURRENT_SEX = `current-${cleanRut}-SEX`
    const LOCAL_CURRENT_STAGE = `userStage-${cleanRut}-${campaign.id}`
    // console.log({ LOCAL_CURRENT_STAGE })
    localStorage.removeItem(LOCAL_FEEDBACK_FORM)
    localStorage.removeItem(LOCAL_GENERAteD_USERID)
    localStorage.removeItem(LOCAL_STUDY_PATTERN)
    localStorage.removeItem(LOCAL_CURRENT_SEX)
    localStorage.removeItem(LOCAL_CURRENT_STAGE)
    // clear prev responses
    setPrevResponses([])
  }

  const isPublishedAndDateNotPassed =
    campaign.status === 'published' && !isOpenedDate
  const isPublishedAndDatePassed =
    campaign.status === 'published' && isOpenedDate
  // console.log({ isPublishedAndDatePassed, isPublishedAndDateNotPassed });

  return (
    <Row>
      {SKU === 'VOCATION_ONE' && <VocationOneIntro />}
      {SKU === 'VOCATION_JUNIOR' && <VocationJuniorIntro />}
      {SKU === 'VOCATION_START' && <VocationStartIntro />}
      <Col>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: 500, paddingBottom: '1rem' }}>
            Historial de respuestas
          </div>
          {prevResponses.map((response, idx) => {
            return (
              <div
                key={response.id}
                style={{
                  padding: '0.85rem',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                  marginBottom: '0.85rem',
                  display: 'flex',
                  alignItems: 'center',
                  border: 1,
                  fontSize: '0.85rem',
                  borderStyle: 'solid',
                  borderColor: response.submitted ? '#4ade80' : '#9ca3af',
                  borderRadius: '4px',
                  backgroundColor: response.submitted ? '#dcfce7' : '#f3f4f6'
                }}
              >
                <div style={{ marginRight: 4 }}>{idx + 1}.</div>
                {response.submitted ? (
                  <div style={{ color: '#166534' }}>
                    Respuesta ya finalizada:{' '}
                    {formatDistanceToNow(new Date(response.updatedAt), {
                      addSuffix: true,
                      locale: es
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <div>
                      Respuesta pendiente:{' '}
                      {formatDistanceToNow(new Date(response.updatedAt), {
                        addSuffix: true,
                        locale: es
                      })}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <a
                        href={`/r/${response.id}`}
                        style={{ color: theme.colors.textColor }}
                      >
                        Continuar{' '}
                        <span>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 24 24'
                            strokeWidth={1.5}
                            stroke='currentColor'
                            style={{ height: 14, width: 14 }}
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='m8.25 4.5 7.5 7.5-7.5 7.5'
                            />
                          </svg>
                        </span>
                      </a>
                    </div>
                  </div>
                )}
              </div>
            )
          })}
          <div style={{ paddingTop: '2rem', textAlign: 'center' }}>
            <div style={{ paddingBottom: '0.85rem', fontSize: '0.85rem' }}>
              Si no deseas continuar, puedes:
            </div>
            <button
              onClick={handleNewResponse}
              style={{
                padding: '0.85rem',
                paddingRight: '1.5rem',
                paddingLeft: '1.5rem',
                background: theme.colors.brandSolid,
                color: '#fff',
                border: 'none',
                transition: 'all 0.2s',
                padding: '10px 25px',
                borderRadius: '4px',
                fontWeight: 600
              }}
            >
              Empezar una nueva respuesta{' '}
              <span>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  style={{ height: 14, width: 14 }}
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m8.25 4.5 7.5 7.5-7.5 7.5'
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </Col>
      <div>
        <div className='bl' />
        <div className='tr' />
      </div>
    </Row>
  )
}
export default PrevResponses

const VocationOneIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationOneLogo} alt='vocation one logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation One</strong>. Ingresa tu{' '}
        <em>Código de Acceso</em> a continuación.
      </p>
      <p>
        Esta información solo se utilizará para guardar los avances de esta
        encuesta en este dispositivo o computadora, y es requisito para poder
        registrar cada una de tus respuestas.
      </p>
      <p>
        En caso de necesitarlo, puedes retomar tus avances volviendo a
        introducir tu <em>Código de Acceso</em> en esta encuesta.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
)

const VocationJuniorIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationJuniorLogo} alt='vocation junior logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation Junior</strong>. Ingresa tu{' '}
        <em>Código de Acceso</em> a continuación.
      </p>
      <p>
        Esta información solo se utilizará para guardar los avances de esta
        encuesta en este dispositivo o computadora, y es requisito para poder
        registrar cada una de tus respuestas.
      </p>
      <p>
        En caso de necesitarlo, puedes retomar tus avances volviendo a
        introducir tu <em>Código de Acceso</em> en esta encuesta.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
)

const VocationStartIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationStartLogo} alt='vocation start logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation Start</strong>. Ingresa tu{' '}
        <em>Código de Acceso</em> a continuación.
      </p>
      <p>
        Esta información solo se utilizará para guardar los avances de esta
        encuesta en este dispositivo o computadora, y es requisito para poder
        registrar cada una de tus respuestas.
      </p>
      <p>
        En caso de necesitarlo, puedes retomar tus avances volviendo a
        introducir tu <em>Código de Acceso</em> en esta encuesta.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
)
